// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__1ywUe","disabled":"FileBtn_disabled__14Jqo","warn":"FileBtn_warn__13oXS","fade":"FileBtn_fade__2LZBa"};